
/* injects from baggage-loader */

'use strict';

export default class ProjectDonationWizardStep0Controller {

	constructor($log, $timeout, $state, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$state = $state;
		this.Alerts = Alerts;

		// Set the starting donation amount
		this.amount = '10';

	}

	$onInit() {

		if (this.donation.amount) {
			this.amount = this.donation.amount;
		} else {
			this.donation.amount = this.amount;
		}

		if (!this.donation.option) {
			this.donation.option = 'donation';
		}

		if (this.donation.reward_id) {
			let reward = this.rewards.find(r => r.id === this.donation.reward_id);
			if (reward) {
				this.donation.reward_amount = reward.amount;
			}
		}

		this.$log.log(this.donation);
		// this.$log.log('Rewards:', this.rewards);

	}


	/**
	 * Select the donation option
	 * @param {String} option 
	 */
	setDonationOption(option) {

		// Se the donation option
		this.donation.option = option;

		// Reset any selected rewards if the option changes away from donation with reward
		if (option !== 'donation_reward') {
			this.donation.reward_id = '';
			this.donation._reward = '';
		}

	}


	/**
	 * Select the reward option
	 * @param {Object} reward 
	 */
	setRewardOption(reward) {

		// Set the selected reward id
		this.donation.reward_id = reward.id;
		this.donation.reward_amount = reward.amount;

		// Update the donation amount
		this.updateAmount(reward.amount);

	}


	/**
	 * Update the investment amount when the "amount" input fires the "blur" event
	 * Bound to: "onBlur" directive of amount input
	 * @param {String} amount 
	 */
	updateAmount(amount) {
		this.amount = amount;
		this.donation_amount = amount;
		this.donation.amount = amount;
		this.$timeout();
	}


	nextStep() {

		// Validate selections
		if (this.donation.option === 'donation') {

			if (!this.donation.amount || this.donation.amount === '$0' || parseInt(this.donation.amount) === 0) {
				this.Alerts.setLocal({
					msg: 'Please enter a valid donation amount before continuing',
					type: 'danger'
				});
				return false;
			} 

		} 
		else if (this.donation.option === 'donation_reward') {
			if (!this.donation.reward_id) {
				this.Alerts.setLocal({
					msg: 'Please select a donation reward before continuing',
					type: 'danger'
				});
				return false;
			}
		} 

		// Passed all validations, continue to next step
		this.$state.go('project-donation-wizard.step1');

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step0/project-donation-wizard.step0.controller.js